import { IsProd } from "@/constants/config";
import request from "@/utils/request";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export interface ApiHotelItem {
  formatted_address: string;
  points_max: number;
  mid_cash_r: string;
  hotel_id: string;
  sub_brand: string;
  mid_val: number;
  update_epoch: number;
  availability: string;
  point_val_min: number;
  availability_num: number;
  update_time: string;
  max_val: number;
  min_val: number;
  id: string;
  point_val_max: number;
  brand: string;
  image: string;
  g_link: string;
  g_rating: number;
  points_median: number;
  cash_max: number;
  cash_min: number;
  hotel_location: {
    latitude: number;
    longitude: number;
  };
  book_info: {
    cash_rate: number;
    points_rate: number;
    distance: number;
    certificates: string[];
  };
  g_rating_total: number;
  name: string;
  point_val_median: number;
  points_min: number;
  cash_median: number;
  popularity: number;
}

export const getAllHotel = () => {
  return request.post(PATH_PREFIX + "hotel_all", {});
};

export const getHotelPartData = (params: { part: number }) => {
  return request.post(PATH_PREFIX + "hotel_all", params);
};

export interface ApiHotelCalendarItem {
  points_rate: number;
  point_value: string;
  avail_date: string;
  cash_price: number;
  rate_plan: string;
  res_link: string;
}

type ApiHotelInfo = ApiHotelItem;

export const getHotelCalendar = (data: { hotel_id: string; date: string }) => {
  return request.post<
    void,
    {
      data: Array<Record<string, ApiHotelCalendarItem[]>>;
      hotel_info: ApiHotelInfo;
      hide_data: boolean;
    }
  >(PATH_PREFIX + "hotel_calendar", data);
};

export const getHotelBatches = async (options: {
  appendData: (v: ApiHotelItem[]) => void;
  complete: () => void;
}) => {
  /**
   * 分多批次发送请求
   */
  const maxBatch = 3;
  let completeCount = 0;
  for (let index = 0; index < maxBatch; index++) {
    getHotelPartData({ part: index })
      .then((res) => {
        options.appendData(res.data);
      })
      .finally(() => {
        completeCount++;
        if (completeCount >= maxBatch) {
          options.complete();
        }
      });
  }
};

export interface HotelAutoCompleteOptionItem {
  type: string;
  country: string;
  city: string;
  label: string;
  value: string;
  latitude: number;
  longitude: number;
}
export const requestHotelAutoCompleteOptions = (params: { query: string }) => {
  return request.post<void, HotelAutoCompleteOptionItem[]>(
    PATH_PREFIX + "hotel_auto_complete",
    params
  );
};

export const requestHotelBook = (params: {
  date_from: string;
  date_to: string;
  items: { latitude: number; longitude: number; label: string }[];
}) => {
  return request.post<void, ApiHotelItem[]>(PATH_PREFIX + "hotel_book", params);
};
